module.exports = {
	"permanent": "Permanente",
	"buttons": {
		"cancel": "Cancelar",
		"close": "Cerrar",
		"copy": "Copiar",
		"copyFile": "Copiar archivo",
		"copyToClipboard": "Copiar al portapapeles",
		"create": "Crear",
		"delete": "Borrar",
		"download": "Descargar",
		"info": "Info",
		"more": "Más",
		"move": "Mover",
		"moveFile": "Mover archivo",
		"new": "Nuevo",
		"next": "Siguiente",
		"ok": "OK",
		"replace": "Reemplazar",
		"previous": "Anterior",
		"rename": "Renombrar",
		"reportIssue": "Reportar problema",
		"save": "Guardar",
		"search": "Buscar",
		"select": "Seleccionar",
		"share": "Compartir",
		"publish": "Publicar",
		"selectMultiple": "Selección múltiple",
		"schedule": "Programar",
		"switchView": "Cambiar vista",
		"toggleSidebar": "Mostrar/Ocultar menú",
		"update": "Actualizar",
		"upload": "Subir",
		"permalink": "Link permanente"
	},
	"success": {
		"linkCopied": "¡Link copiado!"
	},
	"errors": {
		"forbidden": "No eres bienvenido aquí.",
		"internal": "La verdad es que algo ha ido mal.",
		"notFound": "No se puede acceder a este lugar."
	},
	"files": {
		"folders": "Carpetas",
		"files": "Archivos",
		"body": "Cuerpo",
		"clear": "Limpiar",
		"closePreview": "Cerrar vista previa",
		"home": "Inicio",
		"lastModified": "Última modificación",
		"loading": "Cargando...",
		"lonely": "Uno se siente muy sólo aquí...",
		"metadata": "Metadatos",
		"multipleSelectionEnabled": "Selección múltiple activada",
		"name": "Nombre",
		"size": "Tamaño",
		"sortByName": "Ordenar por nombre",
		"sortBySize": "Ordenar por tamaño",
		"sortByLastModified": "Ordenar por última modificación"
	},
	"help": {
		"click": "seleccionar archivo o carpeta",
		"ctrl": {
			"click": "seleccionar múltiples archivos o carpetas",
			"f": "abre la búsqueda",
			"s": "guarda un archivo o lo descarga a la carpeta en la que estás"
		},
		"del": "elimina los items seleccionados",
		"doubleClick": "abre un archivo o carpeta",
		"esc": "limpia la selección y/o cierra la ventana",
		"f1": "esta información",
		"f2": "renombrar archivo",
		"help": "Ayuda"
	},
	"login": {
		"password": "Contraseña",
		"submit": "Iniciar sesión",
		"username": "Usuario",
		"wrongCredentials": "Usuario y/o contraseña incorrectos"
	},
	"prompts": {
		"copy": "Copiar",
		"copyMessage": "Elige el lugar donde quieres copiar tus archivos:",
		"currentlyNavigating": "Actualmente estás en:",
		"deleteMessageMultiple": "¿Estás seguro que quieres eliminar {count} archivo(s)?",
		"deleteMessageSingle": "¿Estás seguro que quieres eliminar este archivo/carpeta?",
		"deleteTitle": "Borrar archivos",
		"displayName": "Nombre:",
		"download": "Descargar archivos",
		"downloadMessage": "Elige el formato de descarga.",
		"error": "Algo ha fallado",
		"fileInfo": "Información del archivo",
		"filesSelected": "{count} archivos seleccionados.",
		"lastModified": "Última modificación",
		"move": "Mover",
		"moveMessage": "Elige una nueva casa para tus archivo(s)/carpeta(s):",
		"newDir": "Nueva carpeta",
		"newDirMessage": "Escribe el nombre de la nueva carpeta.",
		"newFile": "Nuevo archivo",
		"newFileMessage": "Escribe el nombre del nuevo archivo.",
		"numberDirs": "Número de carpetas",
		"numberFiles": "Número de archivos",
		"replace": "Reemplazar",
		"replaceMessage": "Uno de los archivos ue intentas subir está creando conflicto por su nombre. ¿Quieres cambiar el nombre del ya existente?\n",
		"rename": "Renombrar",
		"renameMessage": "Escribe el nuevo nombre para",
		"show": "Mostrar",
		"size": "Tamaño",
		"schedule": "Programar",
		"scheduleMessage": "Elige una hora y fecha para programar la publicación de este post.",
		"newArchetype": "Crea un nuevo post basado en un arquetipo. Tu archivo será creado en la carpeta de contenido."
	},
	"settings": {
		"admin": "Admin",
		"administrator": "Administrador",
		"allowCommands": "Ejecutar comandos",
		"allowEdit": "Editar, renombrar y borrar archivos o carpetas",
		"allowNew": "Crear nuevos archivos y carpetas",
		"allowPublish": "Publicar nuevos posts y páginas",
		"avoidChanges": "(dejar en blanco para evitar cambios)",
		"changePassword": "Cambiar contraseña",
		"commands": "Comandos",
		"commandsHelp": "Aquí puedes crear comandos que serán ejecutados en los eventos. Debes escribir un comando por linea. Si el evento está relacionado con archivos, como por ejemplo, antes y después de guardar, la variable de entorno \"FILE\" estará  disponible en la ruta del archivo.\n",
		"commandsUpdated": "¡Comandos actualizados!",
		"customStylesheet": "Modificar hoja de estilos",
		"examples": "Ejemplos",
		"globalSettings": "Ajustes globales",
		"language": "Idioma",
		"lockPassword": "Evitar que el usuario cambie la contraseña",
		"newPassword": "Tu nueva contraseña",
		"newPasswordConfirm": "Confirma tu contraseña",
		"newUser": "Nuevo usuario",
		"password": "Contraseña",
		"passwordUpdated": "¡Contraseña actualizada!",
		"permissions": "Permisos",
		"permissionsHelp": "Puedes nombrar al usuario como administrador o elegir los permisos individualmente. Si seleccionas \"Administrador\", todas las otras opciones serán activadas automáticamente. La administración de usuarios es un privilegio de administrador.\n",
		"profileSettings": "Ajustes del perfil",
		"ruleExample1": "previene el acceso a una extensión de archivo (Como .git) en cada carpeta.\n",
		"ruleExample2": "bloquea el acceso al archivo llamado Caddyfile en la carpeta raíz.",
		"rules": "Reglas",
		"rulesHelp1": "Aquí puedes definir un conjunto de reglas de permisos para este usuario específico. Los archivos bloqueados no se mostrarán en las listas y no serán accesibles por el usuario. Puedes utilizar regex y rutas relativas a la raíz del usuario.\n",
		"rulesHelp2": "Cada regla va en una línea diferente, y debe comenzar con la palabra clave {0} or {1}. Entonces, debes escribir {2} si estás usando una expresión regular (REGEX) y luego la expresión o la ruta.\n",
		"scope": "Raíz",
		"settingsUpdated": "¡Ajustes actualizados!",
		"user": "Usuario",
		"userCommands": "Comandos",
		"userCommandsHelp": "Una lista separada por espacios con los comandos permitidos para este usuario. Ejemplo:\n",
		"userCreated": "¡Usuario creado!",
		"userDeleted": "¡Usuario eliminado!",
		"userManagement": "Administración de usuarios",
		"username": "Usuario",
		"users": "Usuarios",
		"userUpdated": "¡Usuario actualizado!"
	},
	"sidebar": {
		"help": "Ayuda",
		"logout": "Cerrar sesión",
		"myFiles": "Mis archivos",
		"newFile": "Nuevo archivo",
		"newFolder": "Nueva carpeta",
		"settings": "Ajustes",
		"siteSettings": "Ajustes del sitio",
		"hugoNew": "Nuevo Hugo",
		"preview": "Vista previa"
	},
	"search": {
		"images": "Images",
		"music": "Música",
		"pdf": "PDF",
		"pressToExecute": "Presiona enter para ejecutar.",
		"pressToSearch": "Presiona enter para buscar.",
		"search": "Buscar...",
		"searchOrCommand": "Buscar o ejecutar un comando...",
		"searchOrSupportedCommand": "Buscar o ejecutar uno de los comandos soportados:",
		"type": "Escribe y presiona enter para buscar.",
		"types": "Tipos",
		"video": "Vídeo",
		"writeToSearch": "Escribe aquí para buscar"
	},
	"languages": {
		"en": "English",
		"it": "Italiano",
		"fr": "Français",
		"pt": "Português",
		"ptBR": "Português (Brasil)",
		"es": "Español",
		"ja": "日本語",
		"zhCN": "中文 (简体)",
		"zhTW": "中文 (繁體)",
		"de": "Deutsch",
		"ru": "Русский",
		"pl": "Polski"
	},
	"time": {
		"unit": "Unidad",
		"seconds": "Segundos",
		"minutes": "Minutos",
		"hours": "Horas",
		"days": "Días"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/es.yaml
// module id = 294
// module chunks = 0